'use strict';

/*** hkt_recipes_blog.js — AJAX filter + lazy-load for Recipes blog ***/

document.addEventListener('DOMContentLoaded', () => {
  const wrapper    = document.querySelector('.hkt-recipes-blog');
  const grid       = document.getElementById('hkt-recipes-grid');
  const noResults  = document.getElementById('hkt-recipes-no-results');
  const filterBtns = document.querySelectorAll('.hkt-recipes__filter-btn');

  if (!wrapper || !grid) return;

  const sectionId = wrapper.dataset.sectionId;

  // ── Fetch section via Shopify Section Rendering API ───────────────────────
  async function fetchSection(url) {
    const sep = url.includes('?') ? '&' : '?';
    const res = await fetch(url + sep + 'sections=' + encodeURIComponent(sectionId));
    if (!res.ok) throw new Error('fetch failed: ' + res.status);
    const data = await res.json();
    return new DOMParser().parseFromString(data[sectionId], 'text/html');
  }

  // ── Sync Load More button from freshly fetched doc ────────────────────────
  function syncLoadMore(doc) {
    const existingWrap = document.getElementById('hkt-recipes-load-more-wrap');
    const newWrap      = doc.getElementById('hkt-recipes-load-more-wrap');

    if (newWrap) {
      const nextUrl = newWrap.querySelector('[data-next-url]').dataset.nextUrl;
      if (existingWrap) {
        existingWrap.querySelector('[data-next-url]').dataset.nextUrl = nextUrl;
        existingWrap.querySelector('.hkt-recipes__load-more-btn').textContent = 'Load More Recipes';
        existingWrap.querySelector('.hkt-recipes__load-more-btn').disabled = false;
        existingWrap.hidden = false;
      } else {
        grid.insertAdjacentElement('afterend', newWrap.cloneNode(true));
      }
    } else {
      if (existingWrap) existingWrap.hidden = true;
    }
  }

  // ── Category filter (AJAX, no page reload) ───────────────────────────────
  filterBtns.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();

      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const url = btn.getAttribute('href');
      window.history.pushState({}, '', url);

      try {
        const doc       = await fetchSection(url);
        const articles  = doc.querySelectorAll('.hkt-recipes__article');
        grid.innerHTML  = '';
        articles.forEach(a => grid.appendChild(a));
        syncLoadMore(doc);
        if (noResults) noResults.hidden = articles.length > 0;
      } catch (err) {
        console.error('hkt_recipes: filter failed', err);
        window.location.href = url; // hard fallback
      }
    });
  });

  // ── Load More (event delegation — button may be re-inserted) ─────────────
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.hkt-recipes__load-more-btn');
    if (!btn) return;

    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    btn.disabled = true;
    btn.textContent = 'Loading…';

    try {
      const doc      = await fetchSection(nextUrl);
      const articles = doc.querySelectorAll('.hkt-recipes__article');
      articles.forEach(a => grid.appendChild(a));
      syncLoadMore(doc);
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Load More Recipes';
      console.error('hkt_recipes: load more failed', err);
    }
  });
});
